import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getAccidentById, updateAccident } from '../redux/apiCalls/accidentApiCall';
import { Oval } from 'react-loader-spinner';
import { toast } from 'react-toastify';
function Info() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { lastAccident, getLoading } = useSelector((state) => state.accident);
  const [formData, setFormData] = useState(lastAccident || {});
  const [copiedTexts, setCopiedTexts] = useState([]);
  const [showOtherInput, setShowOtherInput] = useState(false);
  const options = [
    "Geparkt",
    "Vorfahrt missachtet",
    "Auffahrunfall",
    "Spurwechselunfall",
    "Abbiegeunfall",
    "Überholunfall",
    "Rückwärtsfahren",
    "Einparkunfall",
    "Kreuzungsunfall",
    "Unfall mit Fußgänger oder Radfahrer",
    "Wildunfall",
    "Unfall durch Glätte oder Witterung",
    "Technischer Defekt",
    "Unfallflucht",
    "Anderes ..."
  ];
  useEffect(() => {
    dispatch(getAccidentById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (lastAccident) {
      setFormData(lastAccident);
    }
  }, [lastAccident]);
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setShowOtherInput(value === "Anderes ...");
    if (value === "Anderes ...") {
      setFormData((prevData) => ({ ...prevData, damagePath: "" })); 
    } else {
      handleChange({ target: { name: "damagePath", value } });
    }
  };
  

const handleChange = (e) => {
  const { name, value } = e.target;


  if (name.startsWith('lawyer.')) {
    const [key, subKey] = name.split('.');
    setFormData((prevData) => ({
      ...prevData,
      lawyer: {
        ...prevData.lawyer,
        [subKey]: value,
      },
    }));
  } else if (name.startsWith('legal.')) {
    const [key, subKey] = name.split('.');
    setFormData((prevData) => ({
      ...prevData,
      legal: {
        ...prevData.legal,
        [subKey]: value,
      },
    }));
  } else {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  }
};

  const handleCheckboxChange = (labelText, value, checked) => {
    setCopiedTexts((prevTexts) => {
      let updatedTexts;
      if (checked) {
        updatedTexts = [...prevTexts, `${labelText}: ${value}`]; // ✅ إضافة القيمة
      } else {
        updatedTexts = prevTexts.filter((text) => text !== `${labelText}: ${value}`); // ❌ إزالة القيمة
      }
      
      // ✅ نسخ جميع القيم بعد التحديث
      const textToCopy = updatedTexts.join('\n');
      navigator.clipboard.writeText(textToCopy)
        .then()
        .catch((err) => console.error('فشل النسخ: ', err));

      return updatedTexts;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.damagePath) {
      toast.error("Bitte wählen Sie einen Schadenhergang aus oder geben Sie eine andere Option ein.");
      return;
    }
    // Create an object with only the fields you want to update
    const updatedData = {
      kundenName: formData.kundenName,
      kundenKem: formData.kundenKem,
      email: formData.email,
      definition: formData.definition,
      company: formData.company,    
      damagesRepaired: formData.damagesRepaired,
      damagesNotRepaired: formData.damagesNotRepaired,
      accidentSite: formData.accidentSite,
      damagePath: formData.damagePath,
      tax: formData.tax,
      street: formData.street,
      bank: formData.bank,
      witness: formData.witness,
      oneNote: formData.oneNote,
      oneComment: formData.oneComment,
      status: formData.status,
      lawyer: {
        type: formData.lawyer.type,
        lawyerKind: formData.lawyer.lawyerKind,
      },
      legal: {
        type: formData.legal.type,
        legalKind: formData.legal.legalKind,
      },
      azPolizei: formData.azPolizei,
      scheckheft: formData.scheckheft,
    };

    dispatch(updateAccident(lastAccident._id, updatedData));
  };
  if (!lastAccident) {
    return <div>Loading...</div>;
  }

 
  return (
    <div className="bg-gray-100 min-h-screen p-2 sm:p-8">
      <form onSubmit={handleSubmit} className="p-2 sm:p-6 space-y-4">
        {/* Kunden Name */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Kunden Name</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="kundenName"
              value={formData?.kundenName || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Kunden Name', formData.kundenName, e.target.checked)}
            />
          </div>
        </div>

        {/* Kunden Kennzeichen */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Kunden Kennzeichen</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="kundenKem"
              value={formData?.kundenKem || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Kunden Kennzeichen', formData.kundenKem, e.target.checked)}
            />
          </div>
        </div>

        {/* Kenzeichen von Gegner */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Kenzeichen von Gegner</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="definition"
              value={formData?.definition || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Kenzeichen von Gegner', formData.definition, e.target.checked)}
            />
          </div>
        </div>

        {/* Name/Firma von Gegner */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Name/Firma von Gegner</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="company"
              value={formData?.company || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Name/Firma von Gegner', formData.company, e.target.checked)}
            />
          </div>
        </div>

        {/* Reparierter Vorschaden */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Reparierter Vorschaden</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="damagesRepaired"
              value={formData?.damagesRepaired || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Reparierter Vorschaden', formData.damagesRepaired, e.target.checked)}
            />
          </div>
        </div>

        {/* Altschaden vor den Unfall */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Altschaden vor den Unfall</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="damagesNotRepaired"
              value={formData?.damagesNotRepaired || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Altschaden vor den Unfall', formData.damagesNotRepaired, e.target.checked)}
            />
          </div>
        </div>

        {/* Unfallort */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Unfallort</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="accidentSite"
              value={formData?.accidentSite || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Unfallort', formData.accidentSite, e.target.checked)}
            />
          </div>
        </div>

        {/* Schadenhergang */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Schadenhergang</label>
          <div className="flex w-full items-center gap-2">
            <div className="w-full">
              <select
                name="damagePath"
                value={formData.damagePath || ""}
                onChange={handleSelectChange}
                className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              >
                {options.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
              {showOtherInput && (
                <input
                  type="text"
                  name="damagePath"
                  value={formData.damagePath}
                  onChange={handleChange}
                  className="w-full mt-2 text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
                  placeholder="Andere Option eingeben"
                />
              )}
            </div>
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Schadenhergang', formData.damagePath, e.target.checked)}
            />
          </div>
        </div>

        {/* Vorsteuer */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Vorsteuer</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="tax"
              value={formData?.tax || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Vorsteuer', formData.tax, e.target.checked)}
            />
          </div>
        </div>

        {/* Straße */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Straße</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="street"
              value={formData?.street || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Straße', formData.street, e.target.checked)}
            />
          </div>
        </div>

        {/* Bankverbindung */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Bankverbindung</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="bank"
              value={formData?.bank || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Bankverbindung', formData.bank, e.target.checked)}
            />
          </div>
        </div>

        {/* Email */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Email</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="email"
              name="email"
              value={formData?.email || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Email', formData.email, e.target.checked)}
            />
          </div>
        </div>

        {/* Zeugen Kontaktdaten */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Zeugen Kontaktdaten</label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              name="witness"
              value={formData?.witness || ''}
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2"
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Zeugen Kontaktdaten', formData.witness, e.target.checked)}
            />
          </div>
        </div>

        {/* Status */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Status</label>
          <div className="flex w-full items-center justify-between gap-2">
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="status"
                  value="Finanziert"
                  checked={formData.status === "Finanziert"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Finanziert</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="status"
                  value="Kauf"
                  checked={formData.status === "Kauf"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Kauf</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="status"
                  value="Leasing"
                  checked={formData.status === "Leasing"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Leasing</span>
              </label>
            </div>
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Status', formData.status, e.target.checked)}
            />
          </div>
        </div>

        {/* Rechtsanwalt */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Rechtsanwalt</label>
          <div className="flex w-full items-center gap-2">
            <div className="flex flex-col sm:flex-row gap-2 w-full">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="lawyer.type"
                  value="Europa"
                  checked={formData.lawyer?.type === "Europa"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Europa</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="lawyer.type"
                  value="andere"
                  checked={formData.lawyer?.type === "andere"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">andere:</span>
                <input
                  type="text"
                  name="lawyer.lawyerKind"
                  value={formData.lawyer?.lawyerKind || ''}
                  disabled={formData.lawyer?.type === "Europa"}
                  className="text-sm sm:text-base border bg-[#c8e8ef] rounded p-2 flex-1"
                />
              </label>
            </div>
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Rechtsanwalt', formData.lawyer.type, e.target.checked)}
            />
          </div>
        </div>

        {/* Rechtsschutz */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Rechtsschutz</label>
          <div className="flex w-full items-center gap-2">
            <div className="flex flex-col sm:flex-row gap-2 w-full">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="legal.type"
                  value="Nein"
                  checked={formData.legal?.type === "Nein"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Nein</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="legal.type"
                  value="ja"
                  checked={formData.legal?.type === "ja"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">ja:</span>
                <input
                  type="text"
                  name="legal.legalKind"
                  value={formData.legal?.legalKind || ''}
                  disabled={formData.legal?.type === "Nein"}
                  className="text-sm sm:text-base border bg-[#c8e8ef] rounded p-2 flex-1"
                />
              </label>
            </div>
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Rechtsschutz', formData.legal.type, e.target.checked)}
            />
          </div>
        </div>

        {/* Unfallbericht/Az Polizei */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Unfallbericht/Az Polizei</label>
          <div className="flex w-full items-center gap-2">
            <div className="flex gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="azPolizei"
                  value="Nein"
                  checked={formData.azPolizei === "Nein"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Nein</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="azPolizei"
                  value="ja"
                  checked={formData.azPolizei === "ja"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Ja</span>
              </label>
            </div>
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Unfallbericht/Az Polizei', formData.azPolizei, e.target.checked)}
            />
          </div>
        </div>

        {/* Scheckheft */}
        <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Scheckheft</label>
          <div className="flex w-full items-center gap-2">
            <div className="flex gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="scheckheft"
                  value="Nein"
                  checked={formData.scheckheft === "Nein"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Nein</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="scheckheft"
                  value="ja"
                  checked={formData.scheckheft === "ja"}
                  onChange={handleChange}
                  className="w-5 h-5"
                />
                <span className="text-sm sm:text-base">Ja</span>
              </label>
            </div>
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px]"
              onChange={(e) => handleCheckboxChange('Scheckheft', formData.scheckheft, e.target.checked)}
            />
          </div>
        </div>

        {/* Hinweisen auf RB, NA, 6 Monate */}
        <div className="flex flex-col sm:flex-row sm:items-start w-full gap-2">
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Hinweisen auf RB, NA, 6 Monate</label>
          <div className="flex w-full items-start gap-2">
            <textarea
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2 resize-none"
              rows="3"
              name="oneNote"
              value={formData.oneNote || ''}
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px] mt-2"
              onChange={(e) => handleCheckboxChange('Hinweisen auf RB, NA, 6 Monate', formData.oneNote, e.target.checked)}
            />
          </div>
        </div>

        {/* Bemerkungen */}
        <div className="flex flex-col sm:flex-row sm:items-start w-full gap-2 pb-[5rem]" >
          <label className="font-bold text-sm sm:text-base sm:w-[25%]">Bemerkungen</label>
          <div className="flex w-full items-start gap-2">
            <textarea
              className="w-full text-sm sm:text-base border border-gray-300 bg-[#c8e8ef] rounded p-2 resize-none"
              rows="3"
              name="oneComment"
              value={formData.oneComment || ''}
              onChange={handleChange}
            />
            <input 
              type="checkbox"
              className="w-6 h-6 min-w-[24px] mt-2"
              onChange={(e) => handleCheckboxChange('Bemerkungen', formData.oneComment, e.target.checked)}
            />
          </div>
        </div>

        {/* Submit Button */}
        <div className="fixed sm:static bottom-0 left-0 right-0 bg-white sm:bg-transparent p-2 shadow-lg sm:shadow-none">
          <div className="flex justify-center">
            {!getLoading ? (
              <button
                type="submit"
                className="w-full sm:w-auto bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 rounded-lg text-sm sm:text-base transition-colors"
              >
                Update
              </button>
            ) : (
              <div className="w-full sm:w-auto bg-blue-500 text-white px-8 py-3 rounded-lg flex justify-center">
                <Oval height={24} width={24} color="#fff" />
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

export default Info;